<template>
    <v-list
        :dense="dense"
        :class="list_class"
    >
        <v-list-item
            v-for="permission in permissions"
            :key="permission"
            :class="item_class"
        >
            <v-list-item-icon :class="icon_class">
                <v-icon color="primary">mdi-check-circle</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
                <v-list-item-title class="font-weight-regular">
                    {{ $rc.pretty(permission, 'enum_app_permission') }}
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</template>

<script>
export default {
    props: {
        permissions: {
            type: Array,
            required: true,
        },

        dense: {
            type: Boolean,
            default: true,
        },

        list_class: {
            type: String,
            default: '',
        },

        item_class: {
            type: String,
            default: '',
        },

        icon_class: {
            type: String,
            default: 'mx-2',
        },
    },
};
</script>

<style lang="scss" scoped>
:deep(.v-list-item__title) {
    font-size: 1rem !important;
}
</style>